import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Sección principal del footer */}
        <div className="footer-main">
          {/* Logo y descripción */}
          <div className="footer-section footer-brand">
            <div className="footer-logo">
              <img src="/guincho-logo.png" alt="Guincho Logo" className="footer-logo-img" />
              <span className="footer-logo-text">Guincho Garage</span>
            </div>
            <p className="footer-description">
              Todo lo puedo en Cristo que me fortalece. Filipenses 4:13.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Enlaces rápidos */}
          <div className="footer-section">
            <h3 className="footer-title">Enlaces Rápidos</h3>
            <ul className="footer-links">
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/categorias">Categorías</Link></li>
            </ul>
          </div>


          {/* Contacto */}
          <div className="footer-section">
            <h3 className="footer-title">Contacto</h3>
            <div className="contact-info">
              <div className="contact-item">
                <Phone size={16} />
                <span> +595 981 512047</span>
              </div>
              <div className="contact-item">
                <Mail size={16} />
                <span>danr90@hotmail.com</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>Juan Boggino 946 - Asunción, Paraguay</span>
              </div>
            </div>
          </div>
        </div>

        {/* Línea divisoria */}
        <div className="footer-divider"></div>

        {/* Copyright */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} Guincho Garage. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
